export const SCAN_TROUBLESHOOTING_ILLUSTRATIONS = [
  'cropped-code', 'small-code', 'blurred-code',
  'dense-code', 'multiple-codes', 'unavailable-link'
].map(name => ({src:`/images/scan-guide/${name}.svg`,width:900,height:540}));

export const SCAN_DEVICE_ILLUSTRATIONS = {
  iphone: {src:'/images/scan-guide/iphone.svg',width:520,height:680},
  android: {src:'/images/scan-guide/android.svg',width:520,height:680}
};

// vi/en/ja/th have the six-item editorial guide. The other current locales
// have three items in this order: cropped, blurred, multiple codes.
export const getScanTroubleshootingIllustrations = language =>
  ['vi','en','ja','th'].includes(String(language || '').toLowerCase())
    ? SCAN_TROUBLESHOOTING_ILLUSTRATIONS
    : [0,2,4].map(index => SCAN_TROUBLESHOOTING_ILLUSTRATIONS[index]);
